// extracted by mini-css-extract-plugin
export default {"rating":"nB-z","numberOfStars":"oB-z","count":"pB-z","barGraphSpacing":"qB-z","barGraph":"rB-z"};